const VERSION = '2.0.24b'
export default VERSION
